/**
 * Firestore Collection Names
 */

export const COLLECTIONS = {
  LANDLORDS: 'landlords',
  PROPERTIES: 'properties',
  UNITS: 'units',
  TENANTS: 'tenants',
  PAYMENTS: 'payments',
  REMINDERS: 'reminders',
  AI_LOGS: 'ai_logs',
  DOCS_EMBEDDINGS: 'docs_embeddings',
  LANDLORD_EMBEDDINGS: 'landlord_embeddings',
  RAW_EMAILS: 'raw_emails',
  COMMISSIONS: 'commissions',
  COMMISSION_PAYMENTS: 'commissionPayments',
  COMMISSION_CONFIGS: 'commissionConfigs',
} as const;
